import type { StructuredSearchStore } from "@/components/StructuredSearch/stores/structured-search/structured-search-store";
import { tracesSearchSchema } from "@/components/StructuredSearch/schemas/traces-search-schema";
import { mapStructuredFilterGroupToBackend } from "@/queries/request-log-query";
import type { TracesSearchParams } from "@/queries/traces/fetchTracesSearchPaginated";

export const buildTracesSearchParams = (
  structuredSearchStore: StructuredSearchStore,
): TracesSearchParams => {
  const filterGroup =
    (mapStructuredFilterGroupToBackend(
      tracesSearchSchema.buildPayload({
        filters: structuredSearchStore.filters,
        dateRange: structuredSearchStore.dateRange,
        q: structuredSearchStore.q,
      }),
    ) as TracesSearchParams["filterGroup"]) ?? null;

  const sort = structuredSearchStore.sorting[0];

  return {
    filterGroup,
    ...(sort ? { sortField: sort.id, sortOrder: sort.desc ? "desc" : "asc" } : {}),
  };
};
